import PropTypes from 'prop-types';

import { getIcon } from './utils';

export const PresetToneOfVoiceIcon = ({ className, presetTov }) => {
  const Component = getIcon(presetTov);

  if (!Component) {
    return null;
  }

  return <Component className={className} />;
};

PresetToneOfVoiceIcon.propTypes = {
  className: PropTypes.string,
  presetTov: PropTypes.string,
};
PresetToneOfVoiceIcon.defaultProps = {
  className: null,
  presetTov: null,
};
